export const initializeCoupon = (userProfile, period, discountCode) => {
  let couponToUse = discountCode
  let isAutomaticCoupon = false

  if (!couponToUse && userProfile?.ucc) {
    const couponConfigs = {
      yearly: {
        name: '10% off for 3 months cello',
        couponCode: 'SOCaTsZU'
      },
      monthly: {
        name: '50% off for 3 months cello',
        couponCode: 'MOGgGXF7'
      }
    }

    const config = couponConfigs[period] || couponConfigs.monthly
    couponToUse = config.couponCode
    isAutomaticCoupon = true
  }

  return {
    couponCode: couponToUse,
    shouldShowDiscount: couponToUse && !isAutomaticCoupon
  }
}
